import * as React from 'react'

function SvgNotiQuestionFill(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path d="M14.013 12.319l-.48.357c-.416.312-.541.535-.541.758v.506c.013.363-.216.966-.99.966-.773 0-1.063-.5-1.036-.966v-.818c0-.595.263-1.13 1.083-1.695l.54-.372c.682-.461 1.347-.996 1.347-1.74 0-.906-.651-1.486-1.67-1.486-.96 0-1.64.4-1.765 1.442-.046.402-.416.795-.802.795-.96 0-1.161-.735-1.084-1.374C8.83 6.952 10.315 6 12.095 6 14.802 6 15.9 7.427 15.9 9.33c0 1.398-.774 2.17-1.888 2.989M12 17.999a1.199 1.199 0 11-.002-2.398A1.199 1.199 0 0112 17.999m0-16C6.478 2 2 6.478 2 12c0 5.524 4.478 10 10 10 5.523 0 10-4.476 10-10 0-5.522-4.477-10-10-10" />
    </svg>
  )
}

export default SvgNotiQuestionFill
